
import { useEffect } from 'react';

export const useErrorHandler = () => {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      console.error('Global error caught:', event.error);
      
      // Check for discount modal related errors
      if (event.error?.message?.includes('desconto') || 
          event.error?.message?.includes('discount') ||
          event.error?.message?.includes('aplicar desconto')) {
        console.error('Discount modal error detected:', event.error.message);
        
        // Prevent the error from showing the problematic modal
        event.preventDefault();
        
        // Show a user-friendly message instead
        console.log('Suppressing discount modal error to prevent infinite loop');
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('Unhandled promise rejection:', event.reason);
      
      if (typeof event.reason === 'string' && 
          (event.reason.includes('desconto') || event.reason.includes('discount'))) {
        console.error('Discount-related promise rejection detected');
        event.preventDefault();
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);
};
